import React from 'react'
import "./suitableApps.scss"

//Imagens:
import ImgSuitableApps from "../../../assets/reports/suitableApps.png";
import GooglePlay from "../../../assets/reports/googlePlay.png";
import AppStore from "../../../assets/reports/appStore.png";

import AppStoreIng from "../../../assets/reports/appStoreIngles.webp";
import GooglePlayIng from '../../../assets/reports/googlePlayIngles.png'


import AppStoreEs from '../../../assets/reports/disponible-ios-cybermovil.png'
import GooglePlayEs from '../../../assets/reports/indice.png'

import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';


function AvailableIn({googlePlayImg, appStoreImg}) {
  return (
    <div className='available-in'>
      <img id='google-play' src={googlePlayImg} alt="" />
      <img src={appStoreImg} alt="" />
    </div>
  )
}

function SuitableApps() {

  const { t, i18n } = useTranslation()

  useEffect(() => {
    console.log(i18n.language)
  })

  return (
    <div className='container-suitable-apps'>
      <div className='img-suitable-apps'>
        <img src={ImgSuitableApps} alt="" />
      </div>
      <div className='texts-suitable-apps'>
        <h1>{t("reports.suitable_apps.title")}</h1>
        <br />
        <p>{t("reports.suitable_apps.section_text")}</p>

        {i18n.language === "pt-BR" && <AvailableIn appStoreImg={AppStore} googlePlayImg={GooglePlay} />}
        {i18n.language === "en-US" && <AvailableIn appStoreImg={AppStoreIng} googlePlayImg={GooglePlayIng} />}
        {i18n.language === "es" && <AvailableIn appStoreImg={AppStoreEs} googlePlayImg={GooglePlayEs} />}
      </div>
    </div>
  )
}

export default SuitableApps